
import { MediaServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      deletedFolders: [],
      restoreInProgress: false,
      loadingFolder: false
    };
  },
  methods: {
    async fetchAllDeletedFolders() {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.loadingFolder = true;
        const { data } = await MediaServices.listDeletedFolders({
          altId: this.locationId,
          altType: 'location'
        });
        this.deletedFolders = data;
        this.loadingFolder = false;
      } catch (error) {
        console.log(error);
        this.loadingFolder = false;
      }
    },
    async restoreFolder(folder: any) {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.restoreInProgress = true;
        await MediaServices.restoreFolder({
          altId: this.locationId,
          altType: 'location',
          folderId: folder._id
        });
        this.fetchAllDeletedFolders()
        this.restoreInProgress = false;
      } catch (error) {
        console.error(error);
        this.restoreInProgress = false;
      }
    }
  }
});
